import React from "react";
import agreeIcon from "../../../assets/slider/agree@3x.png";
import "./styles.scss";

const AgreeButton = ({ onClick }) => (
  <img className="card-button" onClick={onClick} src={agreeIcon} alt="✓" />
);

export default AgreeButton;
